// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ea64d9da","45":"ec70279b","347":"56621717","378":"8b6f4601","659":"65b690c0","757":"f61c2d50","898":"981c3217"}[chunkId] + ".chunk.js";
};